import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export function validationCountsReducer(
	state = initialstate.validationcounts,
	action
) {
	switch (action.type) {
		case types.UNLOAD_VALIDATION_COUNTS:
			return {};
		case types.REFRESH_VALIDATION_COUNTS:
			return null;
		case types.GET_VALIDATIONCOUNTS:
			return action.response || state;
		default:
			return state;
	}
}

export function validationDetailsReducer(
	state = initialstate.validationdetails,
	action
) {
	switch (action.type) {
		case types.UNLOAD_VALIDATION_DETAILS:
			return {};
		case types.GET_VALIDATIONDETAILS:
			return action.response || state;
		default:
			return state;
	}
}
